import React from 'react';
import { ResponsiveLine  } from '@nivo/line' 

export default function LineGraph({data}) {
  
  const formatTooltip = value => {
    const valorDecimal = parseFloat(value.replace(',', ''));
    const formattedValue = new Intl.NumberFormat('en-IN', { style: 'decimal', minimumFractionDigits: 2 }).format(parseFloat(valorDecimal));
    return formattedValue.replace(',','');
  };

  const formattedData = data.map(series => ({
    ...series,
    data: series.data.map(point => ({
      ...point,
      y: formatTooltip(point.y)
    }))
  }));

  return(
      <ResponsiveLine
          data={formattedData}
          margin={{ top: 20, right: 110, bottom: 50, left: 60 }}
          xScale={{ type: 'point' }}
          yScale={{ type: 'linear', min: 'auto', max: 'auto'}}
          axisTop={null}
          axisRight={null}
          colors= {['rgb(57, 115, 156)','#6bb577','#b56b6b','#876bb5']}
          axisBottom={{
              orient: 'bottom',
              tickSize: 5,
              tickPadding: 5,
              tickRotation: -30,
              legend: ' ',
              legendOffset: 36,
              legendPosition: 'middle'
          }}
          axisLeft={{
              orient: 'left',
              tickSize: 5,
              tickPadding: 10,
              tickRotation: 0,
              legend: '',
              legendOffset: -40,
              legendPosition: 'middle'
          }}
          pointSize={10}
          pointColor={{ theme: 'background' }}
          pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          pointLabel="y"
          pointLabelYOffset={-12}
          useMesh={true}
          legends={[
              {
                  anchor: 'bottom-right',
                  direction: 'column',
                  justify: false,
                  translateX: 100,
                  translateY: 0,
                  itemsSpacing: 0,
                  itemDirection: 'left-to-right',
                  itemWidth: 80,
                  itemHeight: 20,
                  itemOpacity: 0.75,
                  symbolSize: 12,
                  symbolShape: 'circle',
                  symbolBorderColor: 'rgba(0, 0, 0, .5)',
                  effects: [
                      {
                          on: 'hover',
                          style: {
                              itemBackground: 'rgba(0, 0, 0, .03)',
                              itemOpacity: 1
                          }
                      }
                  ]
              }
          ]}
      />
  )
};